module.exports = __webpack_public_path__ + "9c02544eb7dda5f3c2568d81de9bc66e.png";